import { render, staticRenderFns } from "./ReviewStatusAI.vue?vue&type=template&id=4387c5af&scoped=true&"
import script from "./ReviewStatusAI.vue?vue&type=script&lang=js&"
export * from "./ReviewStatusAI.vue?vue&type=script&lang=js&"
import style0 from "./ReviewStatusAI.vue?vue&type=style&index=0&id=4387c5af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4387c5af",
  null
  
)

export default component.exports